import { Avatar, Box, Link, ListItem, ListItemAvatar, Tooltip, useTheme } from "@mui/material";
import moment, { Duration } from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
import { useRootStore } from "../hooks/useRootStore";
import MarkdownView from "./MarkdownView";
import { Timesheet } from "../data/Timesheet";
import { IssueComment } from "../data/IssueComment";
import type { IssueActivity } from "../data/IssueActivity";
import { ActivityType } from "../data/ActivityType";
import ReplyIcon from '@mui/icons-material/Reply';
import { RefObject } from "react";
import { MDXEditorMethods } from "@mdxeditor/editor";

export default function IssueActivity({ activity, editor }: { activity: IssueActivity, editor?: RefObject<MDXEditorMethods> }) {

    const { userProfile } = useRootStore();
    const theme = useTheme();

    const author = activity.activityType == ActivityType.comment ?
        {
            ID: (activity.data as IssueComment).AuthorID,
            Name: (activity.data as IssueComment).AuthorName ?? 'Система',
            Avatar: (activity.data as IssueComment).AuthorAvatar ?? null,
        } :
        {
            ID: (activity.data as Timesheet).WorkerID,
            Name: (activity.data as Timesheet).WorkerName,
            Avatar: (activity.data as Timesheet).WorkerAvatar ?? null,
        };

    const activityDate = activity.activityType == ActivityType.comment
        ? (activity.data as IssueComment).CreateDate
        : (activity.data as Timesheet).StopDate;

    const comment = activity.activityType == ActivityType.comment
        ? (activity.data as IssueComment).CommentText
        : (activity.data as Timesheet).Comment;

    const reply = () => {
        if (editor) {
            let text = activity.activityType == ActivityType.comment ? (activity.data as IssueComment).CommentText : (activity.data as Timesheet).Comment;                
            text = text.replace(/> .+/g, '').trim();
            text = text.replace(/(?:\r\n( ){0,}\r\n|\r( ){0,}\r|\n( ){0,}\n)/g, '<br />');
            text = text.replace(/(?:\r\n|\r|\n)/g, '<br />');
            const author = (activity.data as IssueComment).AuthorName ?? (activity.data as Timesheet).WorkerName;
            const dt = moment((activity.data as IssueComment).CreateDate ?? (activity.data as Timesheet).StopDate).format('DD.MM.YYYY');
            const link = `issues/${activity.data.IssueID}#activity-${ActivityType[activity.activityType]}-${activity.data.ID}`;
            const href = `[*${author} (${dt}):*](${link} "Перейти к комментарию")`;
            editor.current?.setMarkdown(`> ${href}<br />${text}`);
        }
    }

    const roundDuration = (d: Duration) => {
        if (d.asSeconds() % 60 >= 30) {
            d = d.add('1', 'minute').add(-d.asSeconds() % 60, 'second');
        } else {
            d = d.add(-d.asSeconds() % 60, 'second');
        }
        return d;
    }

    return (
        <ListItem id={`activity-${ActivityType[activity.activityType]}-${activity.data.ID}`} className={"issue-comment" + (author.ID == userProfile?.ID ? ' my' : '')} >
            {author.ID == userProfile?.ID ? '' :
                <ListItemAvatar sx={{ pt: 0.3 }}>
                    <Avatar sx={{ fontSize: '80%', lineHeight: '100%', textAlign: 'center' }}
                        alt={author.Name}
                        src={!author.ID ? "logo.svg" : (author.Avatar ?? '')}
                    >
                        {author.Name[0]}{author.Name.split(' ').length > 1 ? author.Name.split(' ')[1][0] : ''}
                    </Avatar>
                </ListItemAvatar>
            }
            <Box className='issue-comment-main'>
                <Box className={"comment-info" + (activity.activityType === ActivityType.comment ? '' : ' tracked')}>
                    <span>
                        <Link className="issue-comment-author" href={`./employees/${author.ID}`} title="Открыть карточку сотрудника">{author?.Name}</Link>
                        <span className="issue-comment-date">({moment(activityDate).format('DD.MM.YYYY HH:mm')})</span>
                    </span>
                    {!editor ? '' :
                        <Tooltip title="Ответить">
                            <ReplyIcon onClick={reply} sx={{ cursor: 'pointer', ml: 2, width: '20px', height: '20px', color: theme.palette.text.secondary }} />
                        </Tooltip>
                    }
                </Box>

                <Box className="comment-text">
                    <MarkdownView markup={comment ?? ''} />
                </Box>

                {activity.activityType === ActivityType.comment ?
                    '' :
                    <Box className={'tracking' + ((activity.data as Timesheet).IsOffDuty ? ' off-duty' : '')}>
                        {roundDuration(moment.duration((activity.data as Timesheet).Hours * 60 * 60 * 1000)).format("HH:mm:ss", { trim: false })}
                    </Box>
                }
            </Box>
        </ListItem>
    )
}